import React from "react";

import './styles.scss';

import Ripple from "../../../../dumb/Ripple";

export default ({open, onClick}) => (
  <Ripple
    className={['menu-burger', open && 'open'].join(' ')}
    onClick={onClick}
  >
    <span />
    <span />
    <span />
  </Ripple>
)
